import { MakeCall, MakeCallPromise } from 'ha/services/apiV2/createMakeCall';

export interface CommissionPlan {
  percentage: number;
  startDate: string;
}

const getCommissionPlan =
  (makeCall: MakeCall) =>
  (userId: number): MakeCallPromise<CommissionPlan> =>
    makeCall<CommissionPlan>('GET', `/user/${userId}/commission-plan`);

export default getCommissionPlan;
